import React from "react";
import { Fragment, useState } from "react";
import { Transition } from "@headlessui/react";
import { FaClock } from "react-icons/fa"; // React Icon for waiting
import { BsX } from "react-icons/bs"; // React Icon for close

const Toast6 = () => {
  const [show, setShow] = useState(true);

  return (
    <div className="flex flex-col h-96 bg-gray-800 text-white">
      {" "}
      {/* Dark background */}
      <div className="flex w-full flex-col items-center space-y-4 sm:items-end mt-10 pr-10">
        <Transition
          show={show}
          as={Fragment}
          enter="transform ease-out duration-300 transition"
          enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enterTo="translate-y-0 opacity-100 sm:translate-x-0"
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5">
            {" "}
            {/* Dark background */}
            <div className="p-4">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <FaClock
                    className="h-6 w-6 text-blue-500"
                    aria-hidden="true"
                  />
                </div>
                <div className="ml-3 w-0 flex-1 pt-0.5">
                  <p className="text-sm font-medium text-white">
                    Service on the Way
                  </p>{" "}
                  {/* Dark text */}
                  <p className="mt-1 text-sm text-gray-400">
                    The service provider is on the way. Please wait patiently.
                  </p>
                </div>
                <div className="ml-4 flex flex-shrink-0">
                  <button
                    type="button"
                    className="inline-flex rounded-md bg-gray-900 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={() => {
                      setShow(false);
                    }}
                  >
                    <span className="sr-only">Close</span>
                    <BsX className="h-5 w-5" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  );
};

export default Toast6;
